// ** React Imports
import { useContext, useEffect } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import { useState } from "react";

// ** Custom Components
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import Block from "components/layout/Block";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

const rawItems = [
	{
		key: "yes",
		value: "Conversations",
	},
	{
		key: "conversationsWithMedia",
		value: "ConversationsWithMedia",
	},
	{
		key: "no",
		value: "no",
	},
];

export const AllowedNewConversations = ({ state, dispatch }) => {
	const { t } = useTranslation(["common", "userpanel"]);
	const { isPhone } = useContext(deviceTypeContext);

	const [selected, setSelected] = useState(null);
	const items = rawItems.map((item) => ({
		...item,
		content: t(`userpanel:settings.preferences.allow.${item.key}`),
	}));

	useEffect(() => {
		setSelected(
			state.allowConversations
				? "Conversations"
				: state.allowConversationsWithMedia
					? "ConversationsWithMedia"
					: "no",
		);
	}, [state.allowConversations, state.allowConversationsWithMedia]);
	return (
		<Block style={{ width: isPhone ? "100%" : "407px" }}>
			<SelectorSelectSingle
				label={t("userpanel:settings.preferences.allow.conversations")}
				items={items}
				selected={selected}
				onAccept={(value) => {
					if (value === null) {
						return;
					}

					setSelected(value);

					if (value === "no") {
						// Nie
						dispatch({
							type: "NO",
						});
					} else if (value === "Conversations") {
						// Tak
						dispatch({
							type: "YES",
						});
					} else if (value === "ConversationsWithMedia") {
						// Tylko od osób ze zdjęciem profilowym
						dispatch({
							type: "ONLY_WITH_MEDIA",
						});
					}
				}}
				withMobileVersion
				activatorStyleOptions={{
					noPad: true,
					noTopMargin: true,
					flex1: true,
					noFullWidth: true,
				}}
			/>
		</Block>
	);
};
